import { gql, TypedDocumentNode } from '@apollo/client';

import { QueryGetJobPositionsSalaryEstimationArgs } from '@pflegia/data-access';

export type LlpMarketStats = { uniqueEmployers: number; newJobsLast14Days: number };

export const GET_LLP_MARKET_STATS: TypedDocumentNode<{ data?: LlpMarketStats | null }, QueryGetJobPositionsSalaryEstimationArgs> = gql`
  query llpMarketStats($filters: JobPositionsSalaryEstimationInput!) {
    data: llpMarketStats(filters: $filters) {
      uniqueEmployers
      newJobsLast14Days
    }
  }
`;
